import { render, staticRenderFns } from "./milestone-accordion.vue?vue&type=template&id=5381b6b1"
import script from "./milestone-accordion.vue?vue&type=script&lang=ts"
export * from "./milestone-accordion.vue?vue&type=script&lang=ts"
import style0 from "./milestone-accordion.vue?vue&type=style&index=0&id=5381b6b1&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5381b6b1')) {
      api.createRecord('5381b6b1', component.options)
    } else {
      api.reload('5381b6b1', component.options)
    }
    module.hot.accept("./milestone-accordion.vue?vue&type=template&id=5381b6b1", function () {
      api.rerender('5381b6b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/outage-clock/scorecard/milestone-accordion.vue"
export default component.exports